import React, { useEffect } from "react";
import Button from "./Button";

const Modal = ({
  isOpen,
  onCancel,
  onConfirm,
  title,
  children,
  isLoading,
  footer = true,
  formWidth = false,
  fullHeight = false,
  formHeight,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("overflow-hidden"); // Prevent background scroll
    } else {
      document.body.classList.remove("overflow-hidden");
    }
    return () => document.body.classList.remove("overflow-hidden");
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* Modal Background */}
      <div
        className="fixed inset-0 bg-gray-900 bg-opacity-50"
        onClick={onCancel}
      ></div>

      {/* Modal Content (with max height & scrollable) */}
      <div
        className={`relative w-full ${
          formWidth
            ? typeof formWidth === "boolean"
              ? "max-w-96"
              : formWidth
            : "max-w-[90%]"
        } p-6 bg-white rounded-lg shadow-lg transform scale-100 ${
          fullHeight ? "" : formHeight ? formHeight : "max-h-[80vh]"
        } overflow-y-auto`}
      >
        {/* Modal Header */}
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
          <button
            className="text-gray-500 hover:text-gray-700"
            onClick={onCancel}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Modal Body (Scrollable if content is long) */}
        <div className="modal-body mb-6">{children}</div>

        {/* Modal Footer */}
        {footer && (
          <div className="flex justify-end gap-4">
            <Button
              onClick={onConfirm}
              type="primary"
              size="small"
              isLoading={isLoading}
            >
              Confirm
            </Button>
            <Button onClick={onCancel} type="outline" size="small">
              Cancel
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
